import { render, staticRenderFns } from "./SolanHeader.vue?vue&type=template&id=caa3654c&scoped=true&"
import script from "./SolanHeader.vue?vue&type=script&lang=ts&"
export * from "./SolanHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa3654c",
  null
  
)

export default component.exports